var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { includes, pickBy, keys } from 'lodash';
import { TOGGLE_FILTER, CHANGE_SEARCH, RESET_SEARCH_FILTER } from '../actions/searchVideos.actions';
var initState = {
    searchValue: '',
    isFiltered: false,
    filters: {
        authorEmail: [],
        status: [],
        type: [],
        channel: [],
        subChannel: [],
        track: [],
        subTrack: [],
        subSubTrack: [],
    },
};
var checkedIsFiltered = function (filters) {
    var flag = false;
    Object.keys(filters).forEach(function (key) {
        if (filters[key].length)
            flag = true;
    });
    return flag;
};
export default (function (state, _a) {
    var _b;
    if (state === void 0) { state = initState; }
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case CHANGE_SEARCH:
            return __assign(__assign({}, state), { searchValue: payload.key });
        case TOGGLE_FILTER:
            var filters = pickBy(__assign(__assign({}, state.filters), (_b = { subChannel: payload.key === 'channel' ? [] : state.filters.subChannel, track: payload.key === 'channel' || payload.key === 'subChannel' ? [] : state.filters.track, subTrack: payload.key === 'channel' || payload.key === 'subChannel' || payload.key === 'track'
                        ? []
                        : state.filters.subTrack, subSubTrack: payload.key === 'channel' ||
                        payload.key === 'subChannel' ||
                        payload.key === 'track' ||
                        payload.key === 'subTrack'
                        ? []
                        : state.filters.subSubTrack }, _b[payload.key] = !state.filters[payload.key]
                ? [payload.filter]
                : !includes(state.filters[payload.key], payload.filter)
                    ? __spreadArray(__spreadArray([], state.filters[payload.key]), [payload.filter]) : state.filters[payload.key].filter(function (f) { return f !== payload.filter; }), _b)), function (value, key) { return includes(keys(initState.filters), key) || value.length; });
            return __assign(__assign({}, state), { isFiltered: checkedIsFiltered(filters), filters: filters });
        case RESET_SEARCH_FILTER:
            return __assign(__assign({}, state), { filters: initState.filters });
        default:
            return state;
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/searchVideos.reducer.ts
// module id = 1487
// module chunks = 81